import 'react-perfect-scrollbar/dist/css/styles.css';
import React from 'react';
import { useRoutes } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';
import GlobalStyles from 'src/components/GlobalStyles';
import 'src/mixins/chartjs';
import theme from 'src/theme';
import routes from 'src/routes';

// Auth Hook
import { useAuth } from './hooks/auth-hook';
// Auth Context
import { AuthContext } from './shared/context/auth-context';

const App = () => {
  const {
    token,
    login,
    logout,
    userId,
    userName,
    userAvatar,
    userPermission,
    att
  } = useAuth();
  const routing = useRoutes(routes(!!token, userPermission));
  return (
    <AuthContext.Provider value={{
      isLoggedIn: !!token,
      token,
      userId,
      userName,
      userPermission,
      userAvatar,
      login,
      logout,
      att
    }}
    >
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        {routing}
      </ThemeProvider>
    </AuthContext.Provider>
  );
};

export default App;
